<template>
  <div>
    <div class="" ref="selectcontainer">
      <v-select
        ref="select"
        :disabled="disabled"
        :multiple="isMultiple"
        :placeholder="placeHolderSearch"
        :options="optionSearch"
        label="username"
        @search="searchVSelect"
        @input="inputVSelect"
        v-model="modelVSelect"
        @open="onOpen"
        @close="onClose"
        :clearable="true"
        :selectable="(option) => selectableVSelect(option)"
        :filterable="false"
        style="background-color: white"
        :clearSearchOnBlur="clearSearchSub"
      >
        <div slot="no-options">
          <span>{{ checkNodata ? messNoOption : messPlaceHolderOption }}</span>
        </div>

        <template #selected-option="{ username }">
          <!-- <div style=" max-width:90%;overflow: hidden;text-overflow: ellipsis;"> -->
          <span
            style="overflow: hidden; text-overflow: ellipsis"
            :title="username ? username : ''"
          >
            {{ username }}
          </span>
        </template>
        <template slot="option" slot-scope="option">
          <div class="container-option-search-customer">
            <div class="container-option-id">
              <span v-if="isShowID" class="color-blur"> #{{ option.id }} </span>
            </div>
            <div
              style="
                display: flex;
                flex: 1;
                word-break: break-all;
                overflow: hidden;
              "
            >
              <div class="container-option-name mr-10">
                <div class="content-name">
                  <b class="" :title="option.profile.fullname">{{
                    option.profile && option.profile.fullname
                      ? option.profile.fullname
                      : ""
                  }}</b>
                </div>
              </div>
              <div class="container-option-user">
                <div class="content-user">
                  <span class="color-blur" :title="option.username">
                    {{ option.username }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes" class="dp-contents">
            <i :class="iconSearch" aria-hidden="true"></i>
          </span>
        </template>
        <template #list-footer>
          <div
            ref="load"
            v-if="hasInfinity"
            class="has-text-centered is-flex is-justify-content-center is-align-items-center"
          >
            <i class="fa fa-spinner fa-pulse mr-5"></i> <span>Loading ...</span>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>
<script>
  // HOW TO USE
  // - import component
  // - 'result' is result search
  // - 'placeHolderSearch' is string, placeHolder default
  // - 'filter' is filter to call api
  // --- Example ---
  // <search-component
  //             : arrResult.sync="listSearch" =>  singleSearch = false
  //             : result.sync="productSearch" => singleSearch = true
  //             : placeHolderSearch="'Enter a keyword to search'"
  //             : filter="filtersSearch"
  //             : iconSearch="'fa fa-search'"
  //             : singleSearch="false"
  //             : isShowPrice="true"
  //             : isShowStock="false"
  //             : isShowID="false"
  //              @input      =>> return item when selected
  // ></search-component>
  // Product default -> data o day tuong duong page = 1
  // Khi tu search sang infinite -> gan list product = default page 1 -> page  = 1 -> load tiep page 2
  import { customer } from "api";
  import _ from "lodash";
  export default {
    name: "SearchProduct",
    props: {
      listcompare: {
        type: Array,
        default: () => [],
      },
      arrResult: Array,
      result: [Array, Object],
      resultMultiple: Array,
      placeHolderSearch: {
        type: String,
        default: "Enter Customer Name or ID to search.",
      },
      iconSearch: {
        type: String,
        default: "fa fa-search",
      },
      messNoOption: {
        type: String,
        default: "No customers matched your search.",
      },
      messPlaceHolderOption: {
        type: String,
        default: "Enter Customer Name or ID to search.",
      },
      filter: {
        type: Object,
        default: function () {
          return {
            // order: "desc",
            // only: "",
            // sort: "id",
            // category: "",
            // q: ""
            is_active: 1,
            q: "",
          };
        },
      },
      isSelectOutStock: {
        type: Boolean,
        default: true,
      },
      selectable: {
        type: [Boolean, Function],
        default: true,
      },
      isShowID: {
        type: Boolean,
        default: true,
      },
      isShowPrice: {
        type: Boolean,
        default: true,
      },
      isShowStock: {
        type: Boolean,
        default: true,
      },
      singleSearch: {
        type: Boolean,
        default: false,
      },
      addFirst: {
        type: Boolean,
        default: false,
      },
      isMultiple: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      showType: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      listcompare: {
        handler(newVal) {
          // Assign list product for comparison to disable
          // if (newVal.length !== 0) {
          this.productsSearch = newVal;
          // }
        },
        immediate: true,
        deep: true,
      },
      result: {
        handler(newVal) {
          this.initData();
        },
        immediate: true,
        deep: true,
      },
      filter: {
        handler(newVal) {
          this.filterDefault = { ...this.filterDefault, ...newVal };
        },
        immediate: true,
        deep: true,
      },
    },
    components: {},
    beforeDestroy() {
      this.observer.disconnect();
    },
    data() {
      return {
        // result: [],
        modelVSelect: [], //v-model select
        productsSearch: [], //list result
        products: [], // list option to search
        customersDefault: [],
        checkNodata: false,
        currency: "",
        filterDefault: { ...this.filter, limit: 10, page: 1 },
        total: "",
        isInfiniteScroll: true,
        observer: null,
        searchString: "",
        isLast: false,
      };
    },
    methods: {
      displayStock(stock) {
        if (stock == null || stock == undefined) return;
        const result = parseInt(stock);
        return result > 0 ? result : result < 0 ? "∞" : "0";
      },
      initData() {
        if (this.singleSearch) {
          this.modelVSelect = this.result ? this.result : null;
        }
        if (this.isMultiple && this.singleSearch) {
          this.modelVSelect = this.result ? [...this.result] : null;
        }
        if (!this.singleSearch) {
          // this.productsSearch = this.result ? this.result : []
        }
      },
      withPopper(dropdownList, component, { width }) {},
      selectableVSelect(option) {
        let result = true;
        // Check can select if product is out stock
        // if (!this.isSelectOutStock && option.status.includes('out_of_stock')) {
        //   return false
        // }
        // if (!this.selectable) return true
        // this.productsSearch.map(k => {
        //   if (option.id == k.id) {
        //     result = false
        //   }
        //   if (!this.isSelectOutStock && option.status.includes('out_of_stock')) {
        //     result = false
        //   }
        // })
        return result;
      },
      clearSearchSub(data) {
        return !data.clearSearchOnSelect && !data.multiple;
      },
      async searchVSelect(text, loading) {
        this.searchString = text;
        this.filter.q = this.searchString;
        if (!this.searchString && this.$refs.select.open) {
          this.products = [...this.customersDefault];
          // this.filterDefault.page = 1
          loading(false);
          await this.$nextTick();
          this.onOpen();
          return;
        } else if (this.searchString.length) {
          this.isInfiniteScroll = false;
          loading(true);
          this.searchDebounce(loading, text, this);
        }
      },
      searchDebounce: _.debounce((loading, text, vm) => {
        if (vm.searchString) {
          vm.getSearchProduct(loading, text);
        }
      }, 500),
      async onOpen() {
        // Check if no search text & options list is open -> call infinite loading
        if (this.hasInfinity) {
          await this.$nextTick();
          this.observer.observe(this.$refs.load);
        }
        if (this.isLast) {
          return;
        }
        if (this.searchString == "" && this.$refs.select.open) {
          this.isInfiniteScroll = true;
        }
        if (this.products.length < 10) {
          this.isInfiniteScroll = false;
        }
      },
      getSearchProduct(loading, text) {
        customer
          .searchCustomer(this.filter)
          .then((res) => {
            if (res.data.success) {
              this.products = res.data.data;
              if (res.data.data.length > 0) {
                this.checkNodata = false;
              } else {
                this.checkNodata = true;
              }
              loading(false);
            }
          })
          .catch((err) => {
            loading(false);
          });
      },
      inputVSelect(data) {
        if (!this.singleSearch) {
          // this.products = [];
          this.productsSearch = this.result ? [...this.result] : [];
          if (this.addFirst) {
            this.productsSearch.unshift(data);
          } else {
            this.productsSearch.push(data);
          }
          this.modelVSelect = [];

          this.$emit("update:result", this.productsSearch);
        } else {
          this.$emit("update:result", data);
        }
        if (this.isMultiple) {
          this.$emit("update:result", data);
        }
        this.$emit("input", data);
        if (!this.searchString) return;
        this.products = [...this.customersDefault];
        // this.productsSearch = []
      },
      getCurrency() {
        this.currency =
          this.$store && this.$store.getters.currency
            ? this.$store.getters.currency
            : JSON.parse(window.localStorage.getItem("vuex")).app.currency;
      },
      getCustomerDefault() {
        let loader = this.$loading.show({
          container: this.$refs.selectcontainer,
          isFullPage: false,
          width: 20,
          height: 20,
          opacity: 0.4,
        });
        customer
          .searchCustomer(this.filterDefault)
          .then((res) => {
            loader.hide();
            if (res.data.success) {
              this.products = res.data.data.data;
              this.customersDefault = [...res.data.data.data];
              if (this.products.length < 10) {
                this.isInfiniteScroll = false;
              }
            }
          })
          .catch((err) => {
            loader.hide();
          });
      },
      async infiniteScroll([{ isIntersecting, target }]) {
        if (isIntersecting) {
          const boxContainer = target.offsetParent;
          const scrollTop = target.offsetParent.scrollTop;
          this.filterDefault.page += 1;
          // if (this.filterDefault.page === 1) return
          try {
            const { data } = await customer.searchCustomer(this.filterDefault);
            this.customersDefault.push(...data.data.data);
            this.products.push(...data.data.data);
            this.total = data.data.total;
            if (data.data.data.length < 10) {
              this.isInfiniteScroll = false;
              this.isLast = true;
            }
          } catch (error) {
            console.log("error :>> ", error);
          }
          await this.$nextTick();
          boxContainer.scrollTop = parseInt(scrollTop);
        }
      },
      onClose() {
        // this.filterDefault.page = 1
        if (this.searchString) return;
        // this.products = [...this.customersDefault]

        // this.observer.disconnect();
      },
    },
    mounted() {
      this.observer = new IntersectionObserver(this.infiniteScroll);
      this.getCustomerDefault();
    },
    created() {
      // this.getCurrency()
    },
    computed: {
      optionSearch() {
        return this.products;
      },
      hasInfinity() {
        return this.isInfiniteScroll;
      },
    },
  };
</script>
<style lang="scss" scoped>
  /deep/.vs__selected {
    width: calc(100% - 20px) !important;
  }
  /deep/ .vs__selected-options {
    width: calc(100% - 100px) !important;
  }
  .vs__dropdown-option--highlight {
    .color-blur {
      color: #efefef;
    }
  }
  .vs--open .vs__open-indicator {
    //remove css transform rotate 180 icon search
    transform: none;
  }
  .dp-contents {
    display: contents;
  }
  .container-option-search-customer {
    padding: 5px 0;
    display: flex;
  }
  .container-option-id {
    .img {
      object-fit: contain;
    }
    display: flex;
    margin-right: 10px;
    // width: 35px;
    // height: 60px;
  }
  .container-option-name {
    // display: flex;
    // flex: 7;
    align-items: center;
    // white-space: normal;
    width: 50%;
  }
  .content-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // max-width: 150px;
  }
  .container-option-user {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    width: 50%;

    // align-items: flex-start;
  }
  .content-user {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // max-width: 150px;
  }
  .price-sale__custom {
    text-align: right;
    // padding-bottom: 5px;
    line-height: 8px;
  }
  .badge__search {
    background-color: #ccc;
    border-radius: 10px;
    padding: 0 4px;
    border-radius: 10px;
    font-size: 0.8em;
    width: 45px;
  }

  .color-blur {
    color: #969696;
  }
</style>
<style>
  .vs__selected-options > input.vs__search::placeholder {
    color: #ccc !important;
  }
</style>
